<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="container">
      <div class="row">
        <draggable v-model="componentData" :animation="300" class="accordion">
          <template #item="{ element: accordion, index: index }">
            <div class="accordion-item mb-2">
              <h2 class="accordion-header ">
                <button :aria-controls="'accordion-' + index" :aria-expanded="false"
                        :data-bs-target="'#accordion-' + index" :data-bs-toggle="'collapse'"
                        class="accordion-button collapsed "
                        @click="toggleAccordion(index)">
                  {{ accordion.section_title }}
                </button>
              </h2>
              <div :id="'accordion-' + index" :class="{ show: accordion.open }" :data-bs-parent="'#accordion-' + index"
                   class="accordion-collapse collapse" role="tabpanel">
                <div class="accordion-body">
                  <div class="accordion-body">
                    <div class="mb-3">
                      <div class="input-label">Section Title</div>
                      <input v-model="accordion.section_title" class="form-control" type="text">
                    </div>
                    <div class="mb-3">
                      <div class="input-label">Section Title Eng</div>
                      <input v-model="accordion.section_title_en" class="form-control" type="text">
                    </div>
                    <div class="mb-3 ">
                      <div class="input-label">Menu Type (Optional)</div>
                      <select v-model="accordion.menu_type_id"
                              class="py-2 border border-secondary rounded px-2 me-2 mb-3">
                        <option value="0">-- Select Menu Type (Optional) --</option>
                        <option v-for="(menuCategoryInfo, index) in menuCategoryTypes" :key="index"
                                :value="menuCategoryInfo.l_portal_menu_type_id">
                          {{ menuCategoryInfo.menu_name }}
                        </option>
                      </select>

                    </div>
                    <div class="mb-3 ">
                      <div class="input-label">Status</div>
                      <div class="form-check ms-2">
                        <input v-model="accordion.active_yn" class="form-check-input" type="radio" value="Y">
                        <label class="form-check-label">Active</label>
                      </div>
                      <div class="form-check ms-2">
                        <input v-model="accordion.active_yn" class="form-check-input" type="radio" value="N">
                        <label class="form-check-label">Inactive</label>
                      </div>
                    </div>
                    <div>
                      <div class="input-label">Section Image</div>
                      <div>
                        <div class="d-flex justify-content-start">
                          <button class="btn btn-light border border-dark" @click="showModalList[index] = true">Add
                            Media
                          </button>
                        </div>
                        <div v-if="showModalList[index]">
                          <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel"
                               aria-modal="true"
                               class="modal fade show" role="dialog" style="display: block;"
                               tabindex="-1">
                            <div class="modal-dialog modal-xl">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                                  <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                                          @click="toggleModel(index)"></button>
                                </div>
                                <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                                  <select-logo :id="componentData[index].section_img_id"
                                               :fetchId="componentData[index].section_img_id"
                                               :sectionIndex="index"
                                               @logoImg="getSectionImg"/>
                                </div>

                                <div class="modal-footer">
                                  <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                                          @click="onConfirmImage(index)">Confirm
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <figure v-if="componentData[index].section_image_url" class="figure"
                                style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
                          <div v-if="componentData[index].section_image_url != null">
                            <img :src="imageBasePath + componentData[index].section_image_url"
                                 style="min-height: 100px;max-height: 130px;max-width: 60%;object-fit: contain">
                          </div>
                        </figure>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="input-label">Section Link</div>
                      <input v-model="accordion.section_link" class="form-control" type="text">
                    </div>
                    <div>
                      <div class="input-label">Section Content</div>
                      <textarea v-model="accordion.section_content" class="form-control"></textarea>
                      <!-- <Editor @htmlDataWithIndex='getHtmlContent' @htmlData="dummy" :htmlFetch="accordion.section_content" -->
                      <!-- :index="index"> -->
                      <!-- </Editor> -->
                    </div>
                    <div class="mt-2">
                      <button v-if="accordion.id" class="btn btn-danger" type="button"
                              @click="deleteSection(accordion.id, accordion.type)">Delete
                      </button>
                      <button v-if="!accordion.id" class="btn btn-danger" type="button"
                              @click="componentData.splice(index, 1)">Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </draggable>
        <div>
          <div class="mt-2">
            <button class="btn btn-dark me-3" style="height: 5vh; font-size: 16px;" type="button"
                    @click="addAccordion()">
              Add
            </button>
            <button class="btn btn-primary" style="height: 5vh; font-size: 16px;" type="button" @click="saveChanges">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectLogo from '@/components/Media/SelectLogo.vue';
import sidebarService from '@/services/sidebar-service.js';
import {notify} from "@kyvg/vue3-notification";
import Config from '@/config/index';
import portalMenuService from '@/services/portal-menu.service';
// import Editor from "@/components/Editor";
import draggable from 'vuedraggable';

export default {
  name: "SidebarComponent",
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          to: '/portal-header'
        }, {
          text: 'Sidebar',
          href: '#'
        }
      ],
      dragging: false,
      menuStructure: null,
      image_paths: [],
      sideBarData: [],
      componentData: [],
      showModal: false,
      showModalList: [false],
      section_img_path: null,
      index: null,
      sectionIndex: null,
      imageBasePath: null,
      tempImageData: null,
      menuCategoryTypes: [],
    };
  },
  components: {
    "select-logo": selectLogo,
    "draggable": draggable,
  },
  async created() {
    this.imageBasePath = Config.apiFileBasePath;
    this.getMenuData();
    this.getSidebar();
  },
  methods: {
    getSectionImg(data) {
      this.tempImageData = data;
    },
    onConfirmImage(index) {
      this.componentData[index].section_img_id = this.tempImageData.media_file_id;
      this.componentData[index].section_image_url = this.tempImageData.file_path;
      this.tempImageData = null;
      this.showModalList[index] = false;
    },
    toggleModel(index) {
      this.tempImageData = null;
      this.showModalList[index] = false;
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Sidebar',
        text: message,
      });
    },

    async deleteSection(id, type) {
      if (type && type == "complaint") {
        notify({
          type: "error",
          title: "Delete Section",
          text: "This item must not be deleted!",
        });
        return
      }
      const response = await sidebarService.deleteSidebar({"id": id});
      if (response.data['messageCode'] == 1) {
        notify({
          type: "success",
          title: "Delete Section",
          text: response.data["message"],
        });
        this.getSidebar();
      } else {
        notify({
          type: "error",
          title: "Delete Section",
          text: response.data.message,
        });
      }
    },

    async getSidebar() {
      this.componentData = [];
      const response = await sidebarService.getSidebar();
      if (response.data) {
        this.componentData = response.data;
        for (let i = 0; i < this.componentData.length; i++) {
          this.showModalList.push(false);
        }
        // for (let i = 0; i < response.data.length; i++) {
        //   this.componentData.push({
        //     id: response.data[i].id,
        //     section_title: response.data[i].section_title,
        //     section_title_en: response.data[i].section_title_en,
        //     active_yn: response.data[i].active_yn,
        //     section_image_url: response.data[i].section_image_url,
        //     section_img_id: response.data[i].section_img_id,
        //     section_link: response.data[i].section_link,
        //     section_content: response.data[i].section_content,
        //     menu_type_id: response.data[i].menu_type_id,
        //   });

        // }

      }
    },
    async getMenuData() {
      const menuCategoryResponse = await portalMenuService.getMenuCategories();
      if (menuCategoryResponse.data != null) {
        this.menuCategoryTypes = menuCategoryResponse.data;
        this.menuCategoryTypes = this.menuCategoryTypes.filter(item => item.l_portal_menu_type_id !== 1);
        this.selectedMenuOption = this.menuCategoryTypes[0];
      }
    },
    getHtmlContent(data) {
      this.componentData[data.index].section_content = data.htmlData;
    },
    addAccordion() {
      this.showModalList.push(false);
      this.componentData.push({
        section_title: "",
        section_title_en: "",
        active_yn: "",
        section_image_url: "",
        section_img_id: "",
        section_link: "",
        section_content: "",
        menu_type_id: null,
      });

      this.sideBarData.push({
        open: true,
      });
    },
    toggleAccordion(index) {
      this.sideBarData.forEach((accordion, i) => {
        if (i === index) {
          accordion.open = !accordion.open;
        } else {
          accordion.open = false;
        }
      });
    },
    async saveChanges() {
      for (let i = 0; i < this.componentData.length; i++) {
        this.componentData[i].position = i;
      }
      const response = await sidebarService.updateSidebar(this.componentData);
      if (response) {
        if (response.data['messageCode'] == 1) {
          notify({
            type: "success",
            title: "Add Section",
            text: response.data["message"],
          });
          this.componentData = [];
          this.getSidebar();
        } else {
          notify({
            type: "error",
            title: "Add Section",
            text: response.data.message,
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.input-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  margin-left: 2px;
}
</style>